import { hasPermissionToRead } from "common/functions/roles";
import { areSitesSubsetOfSites } from "common/functions/sites";
import type { Context } from "common/types/context";
import type { Filter } from "common/types/filters";

const areRolesEditable = (context: Context, filter: Filter) => {
  const { userTypes, role } = context;
  const { defaults, roleIds } = filter;
  return (
    hasPermissionToRead(userTypes, role, "Roles") ||
    !(roleIds?.length || defaults?.length)
  );
};

export const isFilterEditable = (context: Context, filter: Filter) => {
  return (
    !!filter &&
    areRolesEditable(context, filter) &&
    areSitesSubsetOfSites(
      context.sites,
      context.sites.map((s) => s.name),
      filter.sites,
    )
  );
};
